export default "__VITE_ASSET__BT9RX7_w__"